import { IApplicationState } from '../../types/redux';
import { selectNewbuilding } from './selectNewbuilding';

export const selectIsProblem = (state: IApplicationState): boolean => {
  const { isProblem } = selectNewbuilding(state);

  return isProblem;
};
